import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '@/types';

interface UserState {
  user: User | null;
  isConnected: boolean;
  isLoading: boolean;
  error: string | null;
}

const initialState: UserState = {
  user: null,
  isConnected: false,
  isLoading: false,
  error: null,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.isConnected = true;
      state.error = null;
    },
    setBalance: (state, action: PayloadAction<User['balance']>) => {
      if (state.user) {
        state.user.balance = action.payload;
      }
    },
    setInviteInfo: (state, action: PayloadAction<{ inviteCode?: string; invitedBy?: string; inviteCount: number }>) => {
      if (state.user) {
        state.user.inviteCode = action.payload.inviteCode;
        state.user.invitedBy = action.payload.invitedBy;
        state.user.inviteCount = action.payload.inviteCount;
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    disconnect: (state) => {
      state.user = null;
      state.isConnected = false;
      state.error = null;
    },
    updateRewards: (state, action: PayloadAction<string>) => {
      if (state.user) {
        state.user.totalRewards = action.payload;
      }
    },
  },
});

export const {
  setUser,
  setBalance,
  setInviteInfo,
  setLoading,
  setError,
  disconnect,
  updateRewards,
} = userSlice.actions;

export default userSlice.reducer; 